import axiosInstance from "./AxiosInstance";

export function getDoorStepEmployeeListApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-employees/?${fparam}`);
}

export function createDoorStepEmployeeApi(data) {
  return axiosInstance.post("api/doorstep-employees/", data);
}

export function getDoorStepEmployeeDetailsApi(id) {
  return axiosInstance.get(`api/doorstep-employees/${id}/`);
}

export function editDoorStepEmployeeDetailsApi(id, data) {
  return axiosInstance.patch(`api/doorstep-employees/${id}/`, data);
}

export function deleteDoorStepEmployeeApi(id) {
  return axiosInstance.delete(`api/doorstep-employees/${id}/`);
}

export function getDoorStepEmployeeAttendanceDataApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-attendance?${fparam}`);
}

export function createDoorStepAttendanceApi(data) {
  return axiosInstance.post(`api/doorstep-attendance`, data);
}

export function getDoorStepEmployeeCheckedAttendanceApi() {
  return axiosInstance.get("api/doorstep-attendance-marked");
}

export function getDoorStepEmployeeSalaryAccountingApi(id, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/payroll-rate-cards/${id}?${fparam}`);
}
export function createDoorStepEmployeeSalaryAccountingApi(id, param, data) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.post(`api/payroll-rate-cards/${id}?${fparam}`, data);
}
export function getDoorStepEmployeeAttendanceDetailsApi(id, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep/attendance-report/${id}?${fparam}`);
}
export function getDoorStepEmployeeAttendanceDetailsExportApi(id, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep/attendance-report/${id}?${fparam}`, {
    responseType: "blob",
  });
}
export function getDoorStepEmployeePayrollDetailsApi(id, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep/payroll-report/${id}?${fparam}`);
}
export function getDoorStepEmployeePayrollDetailsExportApi(id, param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep/payroll-report/${id}?${fparam}`, {
    responseType: "blob",
  });
}
//payroll
export function createDoorStepEmployeePayroll(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.post(`api/doorstep-payrolls/?${fparam}`);
}
export function getDoorStepEmployeePayroll(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-payrolls/?${fparam}`);
}
export function getDoorStepEmployeePayrollExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-payrolls/?${fparam}`, {
    responseType: "blob",
  });
}
export function checkDoorStepEmployeePayroll(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-payroll/completion/?${fparam}`);
}
export function payDoorStepSalaryApi(data) {
  return axiosInstance.post("api/doorstep-payroll-status", data);
}
//utlity
export function getDoorStepEmployeeEarningUtilityListApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/earnings-allowance-categories/?${fparam}`);
}
export function createDoorStepEmployeeEarningUtilityListApi(data) {
  return axiosInstance.post("api/earnings-allowance-categories/", data);
}
export function updateDoorStepEmployeeEarningUtilityListApi(id, data) {
  return axiosInstance.patch(`api/earnings-allowance-categories/${id}`, data);
}
export function deleteDoorStepEmployeeEarningUtilityListApi(id) {
  return axiosInstance.delete(`api/earnings-allowance-categories/${id}`);
}

export function getDoorStepEmployeeAttendanceExportApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/doorstep-attendance-marked?${fparam}`, {
    responseType: "blob",
  });
}
